import classNames from "classnames";
import { TextIcon } from "components/atoms/TextIcon";
import profileImage from "assets/profileImage.png";
import "./index.scss";
import { DESKTOP_WIDTH } from "utils/constants";
import { useAppSelector, useScreenSize } from "hooks";
import { ai_mcat_chat_status } from "state/reducers/layoutSlice";

interface IProps {
  label: string;
  icon?: boolean;
  image: string;
  styles?: string;
  imageStyles?: string;
  onClick?: () => void;
  email?: string;
  theme: "light" | "dark";
}

export const ImageIcon = ({
  label,
  icon = false,
  image,
  styles,
  imageStyles,
  onClick,
  email,
  theme,
}: IProps) => {
    const { aiMCATChatDrawerStatus } = useAppSelector(
      (state: { layout: { aiMCATChatDrawerStatus: ai_mcat_chat_status } }) =>
        state.layout
    );
    const screen = useScreenSize();
  return (
    <div
      className={classNames("text-image-wrapper", { [`${styles}`]: styles },screen.width > DESKTOP_WIDTH &&
                    screen.width < 1600 &&
                    aiMCATChatDrawerStatus === "open" ? "text-image-wrapper-with-drawer":"")}
    >
      <div className="image">
        <img
          className={classNames("image-src", {
            [`${imageStyles}`]: imageStyles,
          })}
          src={image}
          alt=""
        />
      </div>
      <div className="text-icon">
        <TextIcon
          label={label}
          icon={icon}
          onClick={onClick}
          theme={theme}
          email={email}
        />
      </div>
    </div>
  );
};
